import type { IAdViewLink } from "@finn-no/adview-provider-frontend-types";
import { Trans } from "@lingui/react";
import { Icon } from "./Icon.tsx";

type Props = {
  loanWarningLink: IAdViewLink;
};

const LoanWarning = ({ loanWarningLink }: Props) => {
  return (
    <div className="my-24 p-16 border flex flex-col md:flex-row rounded-16 gap-8">
      <Icon name="Warning" size="64px" className="s-icon-negative shrink-0" />
      <div className="flex flex-col">
        <h3 className="t4">
          <Trans id="itemPageLayout.loanWarning.title" message="To borrow money costs money!" />
        </h3>
        <p className="mb-0 text-caption">
          <Trans
            id="itemPageLayout.loanWarning.description"
            message="If you cannot repay the debt on time, you risk receiving a payment default record. This can lead to difficulties in renting housing, signing contracts (such as subscriptions), and obtaining new loans. For support, contact the budget and debt counseling service in your municipality. Contact details are available at <link>{linkTitle}.</link>"
            values={{ linkTitle: loanWarningLink.title }}
            // biome-ignore lint/a11y/useAnchorContent: There is actual text the screen-reader can use here as seen in the message above
            components={{ link: <a href={loanWarningLink.uri} /> }}
          />
        </p>
      </div>
    </div>
  );
};

export default LoanWarning;
